module.exports = __webpack_public_path__ + "static/media/mobile-back.86738ebd.svg";